import useUserStoreV2 from "store/user-store-v2/useUserStoreV2";

const withSkipOnboarding = (Component: React.ComponentType<any>) => {
  return (props: any) => {
    const { skipOnboarding, handleOnboard } = useUserStoreV2();
    return skipOnboarding ? null : (
      <Component {...props} skipOnboarding={skipOnboarding} handleOnboard={handleOnboard} />
    );
  };
};

export default withSkipOnboarding;
